import styled from "styled-components";
import dropDownArrowIcon from "../../../assets/icons/dropDownArrowIcon.svg";
import { pxToRem } from "../../../styles/utils";

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownHeader = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isOpen",
})<{ isOpen: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${pxToRem(8)} ${pxToRem(16)};
  box-sizing: border-box;
  border: ${pxToRem(1)} solid rgb(229, 229, 229);
  border-radius: ${pxToRem(8)};
  background: rgb(250, 250, 250);
  cursor: pointer;
  font-size: ${pxToRem(20)};
  font-weight: 400;

  &::after {
    content: "";
    display: inline-block;
    width: ${pxToRem(24)};
    height: ${pxToRem(24)};
    background: url(${dropDownArrowIcon}) no-repeat center center;
    background-size: contain;
    transform: rotate(${({ isOpen }) => (isOpen ? "180deg" : "0deg")});
    transition: transform 0.2s ease-in-out;
  }
`;

export const DropdownList = styled.ul<{ openUpward: boolean }>`
  position: absolute;
  ${({ openUpward }) => (openUpward ? "bottom: 100%;" : "top: 100%;")}
  left: 0;
  right: 0;
  background: white;
  border: ${pxToRem(1)} solid rgb(229, 229, 229);
  border-radius: ${pxToRem(8)};
  box-shadow: 0px ${pxToRem(4)} ${pxToRem(8)} rgba(0, 0, 0, 0.1);
  margin: 0;
  padding: 0;
  list-style: none;
  z-index: 1000;
`;

export const DropdownListItem = styled.li`
  padding: ${pxToRem(10)} ${pxToRem(16)};
  cursor: pointer;
  font-size: ${pxToRem(20)};
  font-weight: 400;

  &:hover {
    background: rgba(229, 229, 229, 0.5);
  }
`;
